import { AppRoutes } from "../../enums";
import { APP_FEATURE_KEY, AppState, PageError } from "./state";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Program } from "../../services/api";
import { PROGRAM_FEATURE_KEY, ProgramState } from "../program/state";
import { getRequiredHomeStepKeys } from "../../utils/shopify-program-metadata/shopify-program-metadata";

const getState = createFeatureSelector<AppState>(APP_FEATURE_KEY);
const getProgramState = createFeatureSelector<ProgramState>(PROGRAM_FEATURE_KEY);

export const selectUploadImageLoading = createSelector(getState, state => state.uploadImageLoading);

export const selectLanguage = createSelector(getState, state => state.language);

export const selectAccessToken = createSelector(getState, state => state.accessToken);

export const selectDirtyForm = createSelector(getState, state => state.dirtyForm);

export const selectDesignWalletPlatform = createSelector(getState, state => state.pages.design.walletPlatform);

export const selectScheduledWalletPlatform = createSelector(getState, state => state.pages[AppRoutes.scheduled].walletPlatform);

export const selectLocationBasedWalletPlatform = createSelector(getState, state => state.pages[AppRoutes.locationBased].walletPlatform);

export const selectCouponsType = createSelector(getState, state => state.pages[AppRoutes.coupons].type);

export const selectCouponsWalletPlatform = createSelector(getState, state => state.pages[AppRoutes.coupons].walletPlatform);

export const selectAnonymousWalletPlatform = createSelector(getState, state => state.pages[AppRoutes.anonymous].walletPlatform);

export const selectDesignWalletSideVisible = createSelector(getState, state => state.pages.design.walletSideVisible);

export const selectDesignWalletAppleLayout = createSelector(getState, state => state.pages.design.walletAppleLayout);

export const selectSideNavStats = createSelector(getState, state => state.sideNav);

export const selectIframeHost = createSelector(getState, state => state.iframeHost);

export const selectIframeShop = createSelector(getState, state => state.iframeShop);

export const selectIframeProgramId = createSelector(getState, state => state.iframeProgramId);

export const selectIframeProgramName = createSelector(getState, state => state.iframeProgramName);

export const selectIframeIntegrationName = createSelector(getState, state => state.iframeIntegrationName);

export const selectAnalyticsFilters = createSelector(getState, state => state.analyticsFilters);

export const selectUserId = createSelector(getState, state => state.userId);

export const selectHomeCompletedSteps = createSelector(getState, state => state.homeCompletedSteps);
export const selectHomeDismissedGuides = createSelector(getState, state => state.homeDismissedGuides);
export const selectHomeDismissedNotices = createSelector(getState, state => state.homeDismissedNotices);
export const selectHomeExtensionHandles = createSelector(getState, state => state.homeExtensionHandles);
export const selectHomeInstallKey = createSelector(getState, state => state.homeInstallKey);
export const selectHomeSummary = createSelector(getState, state => state.homeSummary);
const selectProgram = createSelector(getProgramState, state => state.program);

export const selectServerDown = createSelector(getState, state => state.serverDown);

export const selectLastRoute = createSelector(getState, state => state.lastRoute);

export const selectOnboardingPending = createSelector(getState, state => state.onboardingPending);

export const selectHomeOnboardingCompleted = createSelector(
  selectHomeCompletedSteps,
  selectIframeIntegrationName,
  selectProgram,
  (completedSteps, integrationName, program) => {
    if (!completedSteps || Object.keys(completedSteps).length === 0) {
      return false;
    }
    const isShopify = integrationName === Program.IntegrationEnum.Shopify;
    const requiredKeys = getRequiredHomeStepKeys(program, isShopify);
    return requiredKeys.every(key => !!completedSteps[key]);
  },
);

// One critical banner at the top of the page: a failed save or delete (the program's formError, with the API reason)
// first, otherwise the last failed operation or invalid submit
export const selectPageError = createSelector(getState, getProgramState, (state, programState): PageError | null => {
  const reason = programState.formError;
  if (!reason) return state.pageError;
  // Without a reason from the API the effects store the generic error key: say how to recover instead
  const message = reason === "TOAST.error.title" ? "PAGE_ERROR.retry" : reason;
  return { title: state.formErrorTitle ?? "TOAST.error.title", message };
});
